import React from "react";
import toast, { Toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import MessageSenderImage from "./Messages/MessageSenderImage";

interface NewMessageToastProps {
   data: LSWebUI.Hubs.NewMessageModel;
   toastInstance: Toast;
}

const NewMessageToast: React.FC<NewMessageToastProps> = ({ data, toastInstance }) => {
   return <div className="ls-toast">
      <div className="ls-toast-message" onClick={() => { }}>
         <MessageSenderImage imageUrl={data.SenderPicture ?? undefined} name={data.SenderFullName ?? undefined} />
         <div className="ls-toast-message-right">
            <div className="h8">{data.SenderFullName}</div>
            <div className="p2 tc-secondary">{data.MessageText}</div>
         </div>
      </div>
      <Link to={`/messages/${data.ChainId}`} className="btn btn-sm btn-transparent" onClick={() => { toast.dismiss(toastInstance.id) }}>Reply</Link>
   </div>;
}

export default NewMessageToast;